import React, { ReactElement } from 'react'
import { IStepProps } from '../../interfaces/Step'
import Checkbox from '../formGroup/Checkbox'
import Card from '../Card/Card'
import PatrimonyCard from './PatrimonyCard'
import Step3FormHook from '../../hooks/Step3FormHook'
import { MAX_CARDS } from '../../enums/common'
import { preventEnterFormSubmit } from '../../services/utils'
import ButtonAddMore from '../ButtonAddMore'
import SubmitButton from '../SubmitButton'

function Step3Form(props: IStepProps): ReactElement {
  const {
    form,
    submitForm,
    addPatrimonyCard,
    removePatrimonyCard,
    updatePatrimonyTypes,
    onCheckboxChange,
    patrimonyCards,
    noPatrimonyChecked,
    no_patrimony,
  } = Step3FormHook(props)
  const { handleSubmit, register, errors, triggerValidation } = form
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form
      onSubmit={handleSubmit(submitForm)}
      onKeyPress={preventEnterFormSubmit}
    >
      <Checkbox
        label="Je ne dispose d’aucun patrimoine (biens immobiliers, mobiliers, épargne...)"
        id="no_patrimony"
        name="no_patrimony"
        checked={no_patrimony === '1' || false}
        register={register}
        onChange={onCheckboxChange}
        labelClassName="fontWeightBold fontSizeSm fontStyleIt"
        className="mb3 mb5md"
      />
      {noPatrimonyChecked && (
        <input
          type="hidden"
          value={0}
          name="patrimony_types[0][patrimoine_montant]"
          ref={register}
        />
      )}
      {!noPatrimonyChecked && (
        <>
          {patrimonyCards.map((item, index) => (
            <Card
              key={item.key}
              removeCard={removePatrimonyCard}
              index={index}
              canBeDeleted={patrimonyCards.length !== 1}
            >
              <PatrimonyCard
                register={register}
                errors={errors}
                index={index}
                patrimony_type={item}
                handleChange={updatePatrimonyTypes}
                triggerValidation={triggerValidation}
              />
            </Card>
          ))}
          {patrimonyCards.length < MAX_CARDS && (
            <ButtonAddMore
              label="Ajouter un autre type de patrimoine"
              handleClick={() => addPatrimonyCard()}
            />
          )}
          {patrimonyCards.length === MAX_CARDS && (
            <p>Vous ne pouvez pas ajouter plus de 10 types de patrimoine.</p>
          )}
        </>
      )}
      <div className="pt5md textRight mb2 mb0md mt4 mt0md">
        <SubmitButton label="Étape suivante" />
      </div>
    </form>
  )
}

export default Step3Form
